<template>
  <div id="root">
    <div v-show="isError" class="alert alert-danger alert-dismissible fade show">
      <button
        type="button"
        aria-hidden="true"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="isError = !isError"
      >
        <i class="nc-icon nc-simple-remove" />
      </button>
      <span>
        <b>{{ error }}</b></span>
    </div>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="21">
        <div class="grid-content make-space-between">
          <h1 style="margin: 0;">
            {{ title }}
          </h1>
        </div>
      </el-col>
      <el-col :span="2" class="center">
        <div class="grid-content" v-if="!error">
          <i
            class="large-icon el-icon-circle-plus icon-btn"
            @click="openNewBSModal()"
          />
        </div>
      </el-col>
    </el-row>
    <r-paginated-search-table
      v-loading="loading"
      element-loading-text="Loading..."
      element-loading-spinner="el-icon-loading"
      :data="bibleStudies"
      :parent-namespace="namespace"
      @updateTable="updateTable()"
    >
      <template v-slot:extras>
        <div class="table-extras">
          <el-switch
            v-model="filterByStatus"
            active-text="All"
            inactive-text="Active"
          />
          <el-switch
            v-model="filterByView"
            active-text="All"
            inactive-text="Mine"
          />
          <el-select
            class="select-default col-md-4"
            filterable
            v-if="isOneOfTheseRoles(['regional'])"
            clearable
            v-model="location"
            placeholder="Select location ..."
          >
            <el-option
              v-for="userLocation in userLocations"
              :key="userLocation.id"
              :label="userLocation.name"
              :value="userLocation.id"
            />
          </el-select>
        </div>
      </template>
      <el-table-column
        v-if="bibleStudies"
        prop="status"
        label="Status"
        width="120"
      />
      <el-table-column
        prop="location_name"
        label="Campus"
        v-if="isOneOfTheseRoles(['regional'])"
      />
      <el-table-column
        label="Leader(s)"
        v-if="isOneOfTheseRoles([
          'regional', 'td', 'missionary', 'affiliate', 'parish-td', 'parish-missionary', 'alumni'
        ])"
      >
        <template v-slot:default="scope">
          <span
            class="clickable-paragraph"
            v-for="(leader, index) in scope.row.leaders"
            :key="leader.id"
            @click="goToPersonProfile(leader.person_id)"
          >
            {{ leader.name }}<span v-if="index < scope.row.leaders.length - 1">,&nbsp;</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="Name"
      />
      <el-table-column
        prop="meeting_time"
        label="Meeting time"
      />
      <el-table-column
        prop="start_date"
        label="Started"
        width="120"
      />
      <el-table-column
        prop="reporting_percentage, reports_missing"
        label="Reporting"
        v-if="!isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])"
      >
        <template
          v-slot:default="scope"
          v-if="!isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])"
        >
          {{ scope.row.reporting_percentage }}% reported,
          <span
            :class="{
              'error-text': scope.row.reports_missing,
            }"
          >{{ scope.row.reports_missing }} missing</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Actions"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click="handleDropdownCommand('show', scope.$index)"
          >
            <i class="el-icon-view el-icon--right" /> Show
          </el-button>
          <!-- <el-dropdown
            split-button
            type="primary"
            size="small"
            @command="handleDropdownCommand($event, scope.$index)"
            @click="handleDropdownCommand('show', scope.$index)"
          >
            <i class="el-icon-view el-icon--right" /> Show
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-edit" command="edit">
                Edit
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </template>
      </el-table-column>
    </r-paginated-search-table>

    <BSNM
      :show="modals.newBSOpen"
      @close="modals.newBSOpen = false; updateTable()"
    />

    <!-- <BSEM
      :show="modals.editBSOpen"
      :bible-study="bibleStudy"
      v-if="bibleStudy"
      @close="modals.editBSOpen = !modals.editBSOpen"
      @submitted="getBibleStudyById()"
    /> -->
  </div>
</template>

<script>
import Vue from 'vue';
import {
    mapState, mapGetters, vuex
} from 'vuex';
import PaginatedSearchTable from '../../components/Shared/PaginatedSearchTable';
import BibleStudiesStoreModule from '../../store/modules/BibleStudies/index';
import BibleStudyNewModal from '../../components/BibleStudy/NewModal';
// import BibleStudyEditModal from '../../components/BibleStudy/EditModal';

const data = 'Bible Studies';

export default {
    app: '#root',
    components: {
        [PaginatedSearchTable.name]: PaginatedSearchTable,
        BSNM: BibleStudyNewModal,
        // BSEM: BibleStudyEditModal,
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
            loading: (state) => state.BibleStudies.loading,
            userLocations: (state) => state.userLocations,
        }),
        ...mapGetters({
            bibleStudies: 'BibleStudies/bibleStudies',
            role: 'role',
            locationFromStore: 'lastLocation'
        }),
        location: {
            get() {
                return this.locationFromStore;
            },
            set(newLocation) {
                this.$store.commit('setLastLocation', newLocation);
                this.updateTable();
            }
        }
    },
    data() {
        return {
            title: 'Bible Studies',
            namespace: 'BibleStudies',
            modals: {
                newBSOpen: false,
                editBSOpen: false,
            },
            filterByStatus: false,
            filterByView: false,
            isError: false
        };
    },
    watch: {
        filterByStatus() {
            this.$store.commit('BibleStudies/Pagination/setCurrentPage', 1);
            this.updateTable();
        },
        filterByView() {
            this.$store.commit('BibleStudies/Pagination/setCurrentPage', 1);
            this.updateTable();
        },
        error() {
            if (this.error) {
                this.isError = true;
            } else {
                this.isError = false;
            }
        },
        role() {
            if (this.isOneOfTheseRoles(['regional'])) {
                this.filterByView = true;
            } else {
                this.updateTable();
            }
        }
    },
    methods: {
        openNewBSModal() {
            // Fetch eligible leaders into state for Create New BS Modal
            this.$store.dispatch(`${this.namespace}/getEligibleLeaders`).then(
                this.modals.editBSOpen = !this.modals.editBSOpen
            );
            // Fetch eligible participants into state for Create New BS Modal
            this.$store.dispatch(`${this.namespace}/getEligibleParticipants`,
                { bibleStudyId: null }).then(
                this.modals.newBSOpen = !this.modals.newBSOpen
            );
        },
        handleDropdownCommand(command, index) {
            switch (command) {
            case 'show':
                this.$router.push({ name: 'BibleStudiesView', params: { id: this.getIdFromIndex(index) } });
                break;
            case 'edit':
                this.modals.editBSOpen = !this.modals.editBSOpen; break;
            default:
                break;
            }
        },
        updateTable() {
            switch (this.filterByStatus === true) {
            case true: // view all
                switch (this.filterByView === true) {
                case true: // view all viewable
                    this.$store.dispatch(`${this.namespace}/getAllViewableBibleStudies`, this.location);
                    break;
                default: // view all mine
                    this.$store.dispatch(`${this.namespace}/getAllMyBibleStudies`, this.location);
                }
                break;
            default: // view active
                switch (this.filterByView === true) {
                case true: // view active viewable
                    this.$store.dispatch(`${this.namespace}/getViewableActiveBibleStudies`, this.location);
                    break;
                default: // view active mine
                    this.$store.dispatch(`${this.namespace}/getMyActiveBibleStudies`, this.location);
                }
                break;
            }
        },
        getIdFromIndex(index) {
            return this.bibleStudies[index].id;
        },
        getBibleStudies() {
            // On created(), get appropriate BS if role has been fetched
            // If role has not been fetched by the time of created(), then role watcher
            // Will updateTable();
            if (this.$store.state.role != null) {
                // If the user is RD, table should show all active bible studies by default
                // Change filter, which on watcher will call updateTable()
                if (this.isOneOfTheseRoles(['regional'])) {
                    this.filterByView = true;
                // Else the user is not RD, table should show my active bible studies by default
                } else {
                    this.updateTable();
                }
            }
        },
        goToPersonProfile(id) {
            this.$router.push({ name: 'PersonShow', params: { id } });
        },
    },
    created() {
        this.$store.commit(`${this.namespace}/Pagination/setItemsPerPage`, 10);
        this.$store.commit(`${this.namespace}/Pagination/setCurrentPage`, 1);
        this.getBibleStudies();
    },
};
</script>

<style>
.el-switch{
  margin: 10px 20px;
}
.make-space-between{
  display: flex;
  justify-content: space-between;
}
.large-icon{
  font-size:  350%;
}
.icon-btn:hover {
  color: #409EFF;
  cursor: pointer;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.row-bg{
  margin-bottom: 15px;
}
.el-table .cell{
  word-wrap: normal;
  word-break: normal;
}
</style>
